import React from "react";
import LoadingButton from "./LoadingButton";
import "./EcomReferencesSection.css";

const EcomReferencesSection = ({ validateExcel, remove, loadingValidate, loadingDelete }) => {
  return (
    <div className="ecom-references-section">
      <h3 className="ecom-references-section__title">Ecom references</h3>
      <div className="ecom-references-section__buttons">
        <LoadingButton
          color="primary"
          variant="contained"
          onClick={validateExcel('simulateUploadEcomExcel')}
          loading={loadingValidate}
        >
          Check
        </LoadingButton>
        <LoadingButton
          variant="contained"
          onClick={remove("deleteEcommerceReference")}
          loading={loadingDelete}
          isDelete={true}
        >
          Delete
        </LoadingButton>
      </div>
    </div>
  );
};

export default EcomReferencesSection;
